var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVolume3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-762.000000, -2423.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/volume3",
    transform: "translate(762.000000, 2423.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(0.000000, 3.000000)",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0488,14.8066 C17.6958,15.1136 17.1518,15.0456 16.8638,14.6706 C16.5768,14.2936 16.6078,13.7136 16.9608,13.4066 C18.1778,12.3816 18.9458,10.7766 18.9458,9.0006 C18.9458,7.2236 18.1778,5.6526 16.9608,4.5946 C16.6078,4.2866 16.5438,3.7056 16.8638,3.3306 C17.1518,2.9536 17.6968,2.8866 18.0488,3.1946 C19.6498,4.5606 20.6438,6.6786 20.6438,9.0016 C20.6748,11.3556 19.6498,13.4406 18.0488,14.8066",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8569,12.3032 C15.5059,12.6152 14.9659,12.5462 14.6809,12.1642 L14.6179,12.0952 C14.3319,11.7472 14.3959,11.1912 14.7439,10.9132 C15.2839,10.4962 15.6019,9.8012 15.6019,9.0012 C15.6019,8.2702 15.2839,7.6102 14.8079,7.1582 C14.4259,6.8102 14.3629,6.2532 14.6809,5.8362 C14.9659,5.4532 15.5079,5.3842 15.8889,5.6982 C16.7789,6.4622 17.3189,7.6452 17.3189,9.0012 C17.3189,10.3552 16.7469,11.5382 15.8569,12.3032",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,16.5014 C13,17.7374 11.458,18.4384 10.401,17.6954 L4.364,13.3694 L1.412,13.3694 C0.663,13.3694 0.002,12.7934 0.002,12.0514 L0,5.9504 C0,5.2504 0.616,4.6314 1.41,4.6314 L4.362,4.6314 L10.399,0.3044 C11.456,-0.4376 12.998,0.2624 12.998,1.4984 L13,16.5014 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9155,17 C19.6755,17 19.4365,16.898 19.2705,16.701 C18.9695,16.345 19.0145,15.813 19.3715,15.512 C19.3975,15.489 22.2525,13.005 22.2525,9 C22.2525,4.966 19.3995,2.512 19.3715,2.488 C19.0145,2.187 18.9695,1.655 19.2705,1.299 C19.5695,0.943 20.1025,0.898 20.4585,1.199 C20.6015,1.319 23.9385,4.19 23.9385,9 C23.9385,13.81 20.6015,16.681 20.4585,16.801 C20.3005,16.935 20.1075,17 19.9155,17",
    id: "Fill-7"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume3);
export default __webpack_public_path__ + "static/media/iconVolume3.05b2a925.svg";
export { ForwardRef as ReactComponent };